<template>
  <div class="f-signPetitionPage">
    <div class="title-container"><h1 >{{activeLanguage.signPetition}}<br> #AlpFoodwayUNESCO </h1></div>
    <signatures-counter></signatures-counter>
    <div class="row">
      <div class="col-lg-6 colg-md-6 col-sm-12">
        <SignCaption></SignCaption>
      </div>
      <div class="col-lg-6 colg-md-6 col-sm-12">
        <SignForm v-on:submittedSign="showModal"></SignForm>
      </div>
    </div>
    <ThankYouModal ref="thankYouModal" v-on:closeModal="hideModal"></ThankYouModal>
  </div>
</template>

<script type="text/babel">
  import SignCaption from './SignCaption'
  import SignForm from './SignForm'
  import ValueSlider from '../../utilComponents/ValueSlider'
  import ThankYouModal from './ThankYouModal'
  import SignaturesCounter from './SignaturesCounter'

  export default {
    name: 'SignPetitionPage',
    components: {SignaturesCounter, ThankYouModal, ValueSlider, SignForm, SignCaption},
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      }
    },
    methods: {
      showModal (petitionerName) {
        this.$refs.thankYouModal.showModal(petitionerName)
      },
      hideModal () {
        this.$refs.thankYouModal.hideModal()
      }
    },
    props: {
      default: {
        type: Object
      }
    },
    mounted () {
      this.$store.commit('setCurrentView', this.default)
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/signPetitionPageComponents/SignPetitionPage.vue